import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAnalyticsProfile } from '@obvious.tech/constellation'

export const AnalyticsProfile = defineEntity('AnalyticsProfile', {
  endpoint: 'analytics/api/AnalyticsProfile',
  schema: SNoop<IAnalyticsProfile>(),
})
